<template>
    <div>
        <h3>{{ title }}</h3>
        <small v-if="typeDatas == 'pim'">{{ product.updated_at }}</small>
        <small v-if="typeDatas == 'prestashop'">{{ compare.review_prestashop_update }}</small>
        <el-form class="row" ref="productForm" :model="product" label-position="top">
            <div class="col-12" v-if="!product.shop_id && typeDatas == 'prestashop'" >
                <h4>Données non présente sur le Prestashop</h4>
            </div>
            <div class="col-12" v-if="product.shop_id || typeDatas == 'pim' " >
                <el-form-item :class="{'is-same': isSame('name'), 'not-is-same': !isSame('name')}" prop="name" label="Désignation">
                    <el-input v-model="product.name"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('short_desc'), 'not-is-same': !isSame('short_desc')}" prop="short_desc" label="Description courte">
                    <el-input type="textarea" v-model="product.short_desc" rows="4"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('description'), 'not-is-same': !isSame('description')}" prop="description" label="Description">
                    <!--<quill-editor class="quill-editor" v-model="product.description" ref="myQuillEditor" :options="editor.options"></quill-editor>-->
                    <editor :config="editorConfig" v-model="product.description"></editor>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('string_technical_desc'), 'not-is-same': !isSame('string_technical_desc')}" prop="technical_desc" label="Descriptif technique">
                    <el-input type="textarea" v-model="product.string_technical_desc" rows="4"></el-input>
                </el-form-item>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('sale_autorized'), 'not-is-same': !isSame('sale_autorized')}" prop="sale_autorized" class="m-0">
                                <el-checkbox border v-model="product.sale_autorized">Authorisé à la vente</el-checkbox>
                            </el-form-item>
                            <el-form-item :class="{'is-same': isSame('indexed'), 'not-is-same': !isSame('indexed')}" prop="indexed">
                                <el-checkbox border v-model="product.indexed">Indéxé</el-checkbox>
                            </el-form-item>
                            <el-form-item :class="{'is-same': isSame('activated'), 'not-is-same': !isSame('activated')}" prop="activated">
                                <el-checkbox border v-model="product.activated">Activé</el-checkbox>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('mf_price_public'), 'not-is-same': !isSame('mf_price_public')}" prop="mf_price" label="Prix">
                                <el-input-number v-model="product.mf_price_public" controls-position="right" :min="1"></el-input-number>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('ecotax'), 'not-is-same': !isSame('ecotax')}" prop="ecotax" label="EcoTax">
                                <el-input-number v-model="product.ecotax" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('date_new'), 'not-is-same': !isSame('date_new')}" prop="date_new" label="Date de nouveauté">
                                <el-date-picker v-model="product.date_new" type="date" placeholder="Choisissez une date" format="dd/MM/yyyy" value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>

                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('popularity'), 'not-is-same': !isSame('popularity')}" prop="popularity" label="Popularité">
                                <el-input-number v-model="product.popularity" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('width'), 'not-is-same': !isSame('width')}" prop="width" label="Largeur">
                                <el-input-number v-model="product.width" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('height'), 'not-is-same': !isSame('height')}" prop="height" label="Hauteur">
                                <el-input-number v-model="product.height" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('depth'), 'not-is-same': !isSame('depth')}" prop="depth" label="Profondeur">
                                <el-input-number v-model="product.depth" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('weight'), 'not-is-same': !isSame('weight')}" prop="weight" label="Poids">
                                <el-input-number v-model="product.weight" controls-position="right" :min="0"></el-input-number>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('youtube_video'), 'not-is-same': !isSame('youtube_video')}" prop="youtube_video" label="URL video Youtube">
                                <el-input type="url" v-model="product.youtube_video">
                                </el-input>
                            </el-form-item>
                            <iframe v-if="product.youtube_video" width="290" height="158" :src="'https://www.youtube.com/embed/'+product.youtube_video" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                        <div class="col-6">
                            <el-form-item :class="{'is-same': isSame('condition'), 'not-is-same': !isSame('condition')}" prop="condition" label="État">
                                <el-select v-model="product.condition" placeholder="État">
                                    <el-option v-for="item in conditionOptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <el-form-item :class="{'is-same': isSame('categories'), 'not-is-same': !isSame('categories')}" prop="category_id" label="Catégorie principale">
                                <el-cascader class="full-width" clearable filterable change-on-select :props="{label: 'name', value: 'id'}" :options="categoriesOptions" v-model="product.categories"></el-cascader>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <el-form-item :class="{'is-same': isSame('brand_id'), 'not-is-same': !isSame('brand_id')}" prop="brand_id" label="Marques">
                                <el-select v-model="product.brand_id" placeholder="Marques">
                                    <el-option v-for="item in brandsOptions" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <el-form-item :class="{'is-same': isSame('external_ref'), 'not-is-same': !isSame('external_ref')}" prop="external_ref" label="Ref fournisseur">
                    <el-input v-model="product.external_ref"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('ean13'), 'not-is-same': !isSame('ean13')}" prop="ean13" label="Code barre">
                    <el-input v-model="product.ean13"></el-input>
                </el-form-item>
                <!-- <el-form-item prop="motocloud_ref" label="Ref motocloud">
                    <el-input v-model="product.motocloud_ref"></el-input>
                </el-form-item> -->
                <el-form-item :class="{'is-same': isSame('mf_prefixe'), 'not-is-same': !isSame('mf_prefixe')}" prop="mf_prefixe" label="Préfixe fournisseur">
                    <el-input v-model="product.mf_prefixe" maxlength="3"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('meta_desc'), 'not-is-same': !isSame('meta_desc')}" prop="meta_desc" label="Meta description">
                    <el-input type="textarea" v-model="product.meta_desc" rows="4"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('meta_title'), 'not-is-same': !isSame('meta_title')}" prop="meta_title" label="Titre SEO">
                    <el-input v-model="product.meta_title"></el-input>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('reapro'), 'not-is-same': !isSame('reapro')}" prop="reapro_type" label="Type de réappro">
                    <el-select v-model="product.reapro" placeholder="Type de réappro">
                        <el-option v-for="item in reaproOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :class="{'is-same': isSame('out_of_stock_message'), 'not-is-same': !isSame('out_of_stock_message')}" prop="out_of_stock_message" label="Message si hors stock">
                    <el-input type="textarea" v-model="product.out_of_stock_message" rows="5"></el-input>
                </el-form-item>
                <div class="row">
                    <div class="col-sm-3 col-lg-2 m-2" v-for="(image, index) in product.images" :key="index">
                        <img v-if="typeof image == 'object'" :src=" '/ic/small/' + image.path" :alt="image.filename" class="rounded img-product-list">
                        <img v-if="typeof image == 'string'" :src="image" class="rounded img-product-list">
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
import editorConfig from '../../editorConfig';
export default {
    data() {
        return {
            conditionOptions: [
                {
                    label: 'Nouveau',
                    value: 'new',
                },
                {
                    label: 'Utilisé',
                    value: 'used',
                },
                {
                    label: 'Reconditionné',
                    value: 'refurbished',
                }
            ],
            reaproOptions: [
                {
                    label: 'Dispo à la vente',
                    value: 'available'
                },
                {
                    label: 'Interdire les commandes',
                    value: 'disable_order'
                }
            ],
            editorConfig: editorConfig,
            editor: {
                options: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                            ['blockquote', 'code-block'],

                            [{ header: 1 }, { header: 2 }], // custom button values
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
                            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

                            [{ header: [1, 2, 3, 4, 5, 6, false] }],

                            [{ color: [] }], // dropdown with defaults from theme
                            [{ align: [] }],

                            ['clean'] // remove formatting button
                        ]
                    }
                }
            },
        }
    },
    computed: {
    },
    props: {
        title: {
            required: true
        },
        product: {
            required: true
        },
        compare: {

        },
        brandsOptions: {
            required: true
        },
        categoriesOptions: {
            required: true
        },
        typeDatas: {
            required: true
        },
    },
    mounted() {
    },
    methods: {
        isSame(field)
        {
            if( typeof this.product[field] == 'object' && typeof this.compare[field] == 'object' ) {
                return JSON.stringify(this.product[field]) == JSON.stringify(this.compare[field])
            }
            return this.product[field] == this.compare[field]
        }
    }
}
</script>

<style lang="scss">
    .is-same {
        .el-input__inner, .el-textarea__inner, .quill-editor, .el-checkbox.is-bordered.is-checked {
            border: 1px solid #67c23a;
        }
    }
    .not-is-same {
        .el-input__inner, .el-textarea__inner, .quill-editor, .el-checkbox.is-bordered.is-checked {
            border: 1px solid #f56c6c;
        }
    }
</style>
